<div
    *transloco="let t"
    class="bazis-list bazis-list_select"
>
    @for (item of menu(); track $index) {
        <div
            class="bazis-item"
            (click)="item.clickFn()"
        >
            {{ t(item.titleKey, item.titleParams) }}
        </div>
    }
</div>
